// removed by extract-text-webpack-plugin
module.exports = {"grey":"#707070","medium-grey":"#9f9f9f","light-grey":"#d4d4d4","prefixInputField":"_38pvu0vUAku1tcxjuwa3zK","isFilled":"w1mh54pi0AvF7WWF5qlyl","prefixInput":"_TAmRxwMcPpAIS20jCJCw","isDisabled":"_29V8yreh1WIRHoLAhwDDqY","locked":"_16XcDonY6dextBNR7fOXq3"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Inputs/PrefixInput.css
// module id = 942
// module chunks = 0